module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAAvElEQVQoU+2RoQrCUBSG//9uB4xWm1g07hUEm/gCZvsY2x7AaFgUbFa7QUw+gj7CsNgdgsV7ZGOTm1wxetIH5zvnwH8Ip+I4XgCYksxJ9q21myzLjo3CJElujt8lWajqC4AA6AAo6v69lA/u9i/8YBiGQxHZtQ2IyIRpmgaqerbWzowx+3LI4auqrkiuSfY+MoAxgFN9oWJVzVV1aYzZ/uWfpXEBENQ5N/wEkAMYVTlHUTTwPG/d9m7f9+dvAfax6n5FiLoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/delete.png
// module id = KuaY
// module chunks = 1